import { Application } from '../../__models__/models';
import { Step } from 'components/job_hiring_steps/models';

export const EOR_SUPPORTED_CANDIDATE_COUNTRIES = ['PT'];

export function isEorEligibleCandidate(application: Application, companyCountryCode: string): boolean {
  if (!companyCountryCode) return false;
  const candidateCountryCode = application.attributes.person.attributes.country_code;
  if (!candidateCountryCode) return false;
  return EOR_SUPPORTED_CANDIDATE_COUNTRIES.includes(candidateCountryCode) &&
    !EOR_SUPPORTED_CANDIDATE_COUNTRIES.includes(companyCountryCode);
}

export function getEorEligibleCandidates(
  applications: Application[],
  companyCountryCode: string
): Application[] {
  if (!companyCountryCode) return [];
  return applications.filter(app => isEorEligibleCandidate(app, companyCountryCode));
}

export function isLateStageStep(step: Step): boolean {
  return step.late_stage === true;
}

export function formatEorCandidateNames(candidates: Application[]): string {
  if (candidates.length === 0) return '';

  const names = candidates.map(c => c.attributes.person.attributes.name);

  if (names.length === 1) return names[0];
  if (names.length === 2) return names.join(' and ');

  return `${names[0]}, ${names[1]} +${names.length - 2}`;
}
